__turbopack_context__.v({
  "testimonial": "Testimonial-module-scss-module__XfVvCa__testimonial",
  "testimonial__author": "Testimonial-module-scss-module__XfVvCa__testimonial__author",
  "testimonial__author-meta": "Testimonial-module-scss-module__XfVvCa__testimonial__author-meta",
  "testimonial__author-name": "Testimonial-module-scss-module__XfVvCa__testimonial__author-name",
  "testimonial__author-text": "Testimonial-module-scss-module__XfVvCa__testimonial__author-text",
  "testimonial__avatar": "Testimonial-module-scss-module__XfVvCa__testimonial__avatar",
  "testimonial__quote": "Testimonial-module-scss-module__XfVvCa__testimonial__quote",
});
